import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { CommitteeService } from 'src/app/services/committee.service';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { NgZone } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-committee-edit',
  templateUrl: './committee-edit.component.html',
  styleUrls: ['./committee-edit.component.css']
})
export class CommitteeEditComponent implements OnInit {

  public environmentSettings: any;

  constructor(private documentManagementMasterService: DocumentManagementMasterService,
    private ngZone: NgZone,
    private customValidation: CustomValidation,
    private route: ActivatedRoute,
    private committeeService: CommitteeService,
    private alert: AlertComponent,
    private directorService: DirectorMasterService,
    private commonFunction: CommonFunction,
    private meetingService: MeetingMasterService,
    private router: Router,
    private authAlert: AuthAlertComponent,
    private loaderService: LoaderService) { }

  @ViewChild(DataTableDirective)
  dtElementDirector: DataTableDirective;


  dtOptionsDirector: DataTables.Settings = {};
  dtTriggerDirector: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementInvitee: DataTableDirective;
  dtOptionsInvitee: DataTables.Settings = {};
  dtTriggerInvitee: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElementMember: DataTableDirective;
  dtOptionsMember: DataTables.Settings = {};
  dtTriggerMember: Subject<any> = new Subject();


  dtOptionsMemberAddingPopup: DataTables.Settings = {};
  dtTriggerMemberAddingPopup: Subject<any> = new Subject();



  membersListFromGovEva: any[];

  committeeName: any[];
  committeeData: any[];
  committeeEditForm: FormGroup;
  committeeNameList: any;
  committeeId: any;
  committeeAlias: any;
  CommitteeShortName: any;
  directorForm: FormGroup;
  inviteeForm: FormGroup;
  memberForm: FormGroup;
  directorData: any[];
  allDirectorDetailsForCommittee: any[];
  availableDirectorsID: any[];
  InviteesList: any[];
  downloadLink: any;
  dinNumber: any;
  otherCommitteeSelected: boolean;
  isOtherNotValid: boolean;
  isAuditCommitteeAvailable: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  dateOfIncorpOfCompany: any;
  futureDate: any;
  DirectorAppointmentDate: any;
  memberAppointmentDate: any;
  activationDateOfCommittee: any;
  charterFileDocName: any;
  policiesFileDocName: any;
  charterFileDocID: any;
  policiesFileDocID: any;
  charterFileIsAvailable: any;
  policiesFileIsAvailable: any;
  policyFileEditFlag: boolean;
  charterFileEditFlag: boolean;
  settingAmount: any;
  warningALertForSettingAmount: any;
  invityMember: any[];
  committeeMember: any[];
  charterfileArray: Array<File>;
  policiesfileArray: Array<File>;
  fileOrignalName: any;
  fileChangedName: any;
  directorIsNotValid: any;
  directorGovEvaID: any;
  isMemberSelected: any
  hideMemberBtn: boolean = true;
  checkInvityMemberExist: boolean = false;
  dir_id: any;
  invitee_id: any;
  member_id: any;
  deletingDirector_id: any;
  deletingInvitee_id: any;
  deletingMember_id: any;
  maxdateOfApp: any
  isExistingInvitteeForInvalid: boolean = true;
  checkEmailIdExistInInvitee: boolean = true;
  allMembers: any = [];
  update: boolean = false;
  todayDateforSearchUser: NgbDateStruct;
  minDateForSearchTo: NgbDateStruct;
  userSearchDateFrom: NgbDateStruct;
  userSearchDateTo: any;
  minDateForSearchFrom: NgbDateStruct;
  token: any = localStorage.getItem('token')
  disabledOnclick: boolean;
  fileExtension: boolean = true;
  changefileExtension: boolean = true;
  editActive: boolean = false;

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {
    this.loaderService.disable();


    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    this.environmentSettings = environment;



    this.dtOptionsDirector = {
      scrollY: "250px",
      stateSave: true,
      stateDuration: -1,
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [6] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // columnDefs: [{ orderable: false, targets: [10] }]
    };
    this.dtOptionsInvitee = {
      scrollY: "250px",
      stateSave: true,
      stateDuration: -1,
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [4] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // columnDefs: [{ orderable: false, targets: [10] }]
    };
    this.dtOptionsMember = {
      scrollY: "250px",
      stateSave: true,
      stateDuration: -1,
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [4] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // columnDefs: [{ orderable: false, targets: [10] }]
    };
    this.dtOptionsMemberAddingPopup = {
      scrollY: "250px",
      stateSave: true,
      stateDuration: -1,
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [0] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // columnDefs: [{ orderable: false, targets: [10] }]
    };

    this.committeeEditForm = new FormGroup({
      committeeName: new FormControl('', []),
      otherCommitteeName: new FormControl('', []),
      committeeAlias: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      CommitteeShortName: new FormControl('', []),
      meetingFrequency: new FormControl('', [Validators.required, Validators.min(1)]),
      meetingGap: new FormControl('', [Validators.min(1)]),
      quorumDirectors: new FormControl('', [Validators.min(1)]),
      meetingNoticePeriod: new FormControl('', [Validators.required]),
      statutoryCommittee: new FormControl('', []),
      activationDate: new FormControl('', [Validators.required]),
      sittingFees: new FormControl('', []),
      charterFileDocId: new FormControl('', []),
      policiesFileDocId: new FormControl('', []),
      financialLiterate: new FormControl('No', []),
      accountingOrRelatedFinancialExpertise: new FormControl('No', [])
    });
    // this.directorForm.controls.DirectorDIN.setValue(element._id);
    // this.directorForm.controls.Chairman.setValue(element._id);
    this.directorForm = new FormGroup({
      DirectorDIN: new FormControl({ disabled: true }),
      GovevaUserId: new FormControl({ disabled: true }),
      MemberName: new FormControl({ disabled: true }, [Validators.required]),
      Designation: new FormControl({ disabled: true }, [Validators.required]),
      Category: new FormControl({ disabled: true }),
      IsExecutive: new FormControl({ disabled: true }),
      Chairman: new FormControl('', [Validators.required]),
      AppointmentDate: new FormControl('', [Validators.required]),
      Tenure: new FormControl('', []),
      CessationDate: new FormControl('', []),
      CessationReason: new FormControl('null', []),
      DirectorID: new FormControl({ value: '' }, []),
      financialLiterate: new FormControl('', []),
      accountingOrRelatedFinancialExpertise: new FormControl('', []),
      EmailID: new FormControl('', []),
      MemberType: new FormControl('', [Validators.required]),
      GovEvaUserDesignation: new FormControl('', [])
    });

    this.inviteeForm = new FormGroup({
      InviteeName: new FormControl('', [Validators.required]),
      Designation: new FormControl('', []),
      Address: new FormControl('', []),
      City: new FormControl('', []),
      State: new FormControl('', []),
      TelO: new FormControl('', []),
      TelR: new FormControl('', []),
      FaxNo: new FormControl('', []),
      MobileNo: new FormControl('', [Validators.required]),
      EmailId: new FormControl('', [Validators.required, Validators.email]),
      InAttendance: new FormControl('', [Validators.required]),
      ThroughVC: new FormControl('', [Validators.required]),
      GovevaUserId: new FormControl('')
    });

    this.memberForm = new FormGroup({
      GovevaUserId: new FormControl({ disabled: true }),
      MemberName: new FormControl('', [Validators.required]),
      Chairman: new FormControl('', [Validators.required]),
      AppointmentDate: new FormControl('', [Validators.required]),
      Tenure: new FormControl('', []),
      CessationDate: new FormControl('', []),
      CessationReason: new FormControl('', []),
      Designation: new FormControl('', []),
      Address: new FormControl('', []),
      City: new FormControl('', []),
      State: new FormControl('', []),
      TelO: new FormControl('', []),
      TelR: new FormControl('', []),
      FaxNo: new FormControl('', []),
      MobileNo: new FormControl('', []),
      EmailId: new FormControl('', [Validators.required, Validators.email]),
      financialLiterate: new FormControl('', []),
      accountingOrRelatedFinancialExpertise: new FormControl('', [])
    });

    this.route.params.subscribe(params => {

      this.committeeId = params['committeeId'];
      var data = {
        module: 'Committee',
        ID: params['committeeId'],
        CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
      }

      this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
        if (meetingAccess.status == 0) {

          this.getCommitteeName();//For UI To Bind DropDown
          this.getOnLoadCredentials();
          // this.getDirectors()
          this.getDirectorDetailsListForTable(this.committeeId);
          // this.getMembersFromGoveva();
          this.downloadLink = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/'
          $("#committeeName").focus();
          this.getInCorpDate();

        } else {

          this.authAlert.validateModuleWithPermissions('Committee', params['committeeId'], meetingAccess.companyID, 'edit')

        }
      })
    });

  }

  back() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['committee'] } }],
      { relativeTo: this.route.parent });
  }
  getInCorpDate() {
    this.dateOfIncorpOfCompany = "";
    this.committeeService.getInCorpDateOfCompany().subscribe(companyDateOfIncorp => {
      let dt = new Date(this.commonFunction.setFormatDate(companyDateOfIncorp.CompanyDetails[0].DateOfIncorporation))
      this.dateOfIncorpOfCompany = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      // console.log('companyDateOfIncorpcompanyDateOfIncorp--------------------------->>>>',this.dateOfIncorpOfCompany);
    })
    let dt = new Date();
    this.futureDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }

  }



  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  limitToAmount() {
    var amount = this.committeeEditForm.controls.sittingFees.value
    if (amount != "") {
      var amountWithoutComma = parseInt(amount.replace(new RegExp(this.escapeRegExp(','), 'g'), ''));
      if (amountWithoutComma <= 100000) {
        this.warningALertForSettingAmount = false;

      } else {
        this.warningALertForSettingAmount = true;
        this.committeeEditForm.controls.sittingFees.setErrors({ 'incorrect': true });
      }
    }

  }

  addMember() {
    this.alreadyExist = false;
    $("#btnUpdateMemberRow").hide();
    $("#btnaddMemberRow").show();
    this.getMembersFromGoveva()
    this.memberForm.reset();
    $('#MemberLabel').html('<i class="fa fa-plus"></i> Member Details :');

    setTimeout(() => {
      $("#memberTablePopup").DataTable().columns.adjust().draw();
    }, 200);

  }

  addInvitee() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#msgDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#msgDialog').modal('show');
    }, 100);
    this.checkEmailIdExistInInvitee = false;
    this.alreadyExist = false;
    this.inviteeForm.controls.InviteeName.enable();
    this.inviteeForm.controls.Designation.enable();
    this.inviteeForm.controls.MobileNo.enable();
    this.inviteeForm.controls.EmailId.enable();
    this.inviteeForm.reset();
    this.inviteeForm.controls.ThroughVC.setValue("No");
    this.inviteeForm.controls.InAttendance.setValue("No");
    $("#btnUpdateInviteeRow").hide();
    $("#btnaddInviteeRow").show();
    $('#InviteeLabel').html('<i class="fa fa-plus"></i> Invitee Details :');
  }



  //For UI To Bind DropDown of committee Name
  getCommitteeName() {
    this.committeeName = [
      // { id: '2', name: 'Other', IsSelected: false }
    ];
  }

  //Form Credentials To Bind On Edit Form
  getOnLoadCredentials() {

    this.isAuditCommitteeAvailable = false;
    this.committeeEditForm.reset();
    this.committeeService.getCommitteeById(this.committeeId)
      .subscribe(committee => {
        if (committee.status == 0) {

          if (committee.committeeData[0].CharterFileDocId == null || committee.committeeData[0].CharterFileDocId == "null" || committee.committeeData[0].CharterFileDocId == undefined) {
            this.charterFileIsAvailable = false;
          } else {
            this.charterFileIsAvailable = true;
            this.getCharterDocumentNameByID(committee.committeeData[0].CharterFileDocId)
          }
          if (committee.committeeData[0].PoliciesFileDocId == null || committee.committeeData[0].PoliciesFileDocId == "null" || committee.committeeData[0].PoliciesFileDocId == undefined) {
            this.policiesFileIsAvailable = false;
          } else {
            this.policiesFileIsAvailable = true;
            this.getPoliciesDocumentNameByID(committee.committeeData[0].PoliciesFileDocId)
          }

          if (committee.committeeData[0].CommitteeName === 'Audit Committee') {
            this.isAuditCommitteeAvailable = true;
          }
          // let charterOriginalFileName=;
          // let policiesOriginalFileName=;
          //  console.log(committee.committeeData[0].CommitteeName);

          this.committeeAlias = committee.committeeData[0].CommitteeAlias;
          this.CommitteeShortName = committee.committeeData[0].CommitteeShortName;
          //this.committeeId = committee.committeeData[0]._id;
          this.committeeName.push({ id: '1', name: committee.committeeData[0].CommitteeName, IsSelected: true });
          if (committee.committeeData[0].CommitteeName != 'Other') {
            this.otherCommitteeSelected = false;
          } else {
            this.otherCommitteeSelected = true;
            this.committeeEditForm.controls.otherCommitteeName.setValue(committee.committeeData[0].OtherCommitteeName);
          }

          //  console.log('-->',committee.committeeData[0])

          this.committeeEditForm.controls.committeeName.setValue(committee.committeeData[0].CommitteeName);
          this.committeeEditForm.controls.committeeAlias.setValue(committee.committeeData[0].CommitteeAlias);
          this.committeeEditForm.controls.CommitteeShortName.setValue(committee.committeeData[0].CommitteeShortName);
          this.committeeEditForm.controls.meetingFrequency.setValue(committee.committeeData[0].MeetingFrequencyInYear);
          this.committeeEditForm.controls.meetingGap.setValue(committee.committeeData[0].MeetingGaps);
          this.committeeEditForm.controls.quorumDirectors.setValue(committee.committeeData[0].QuorumNoofDirectors);
          this.committeeEditForm.controls.meetingNoticePeriod.setValue(committee.committeeData[0].NoticePeriodforMeeting);
          this.committeeEditForm.controls.statutoryCommittee.setValue(committee.committeeData[0].SatutoryCommittee);
          this.activationDateOfCommittee = committee.committeeData[0].ActivationDate;
          let dt = new Date(this.setFormatDate(committee.committeeData[0].ActivationDate));
          // this.CompletedDateModel = ;
          this.committeeEditForm.controls.activationDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
          this.maxdateOfApp = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };

          this.committeeEditForm.controls.sittingFees.setValue(committee.committeeData[0].SittingFees);
          this.committeeEditForm.controls.financialLiterate.setValue(committee.committeeData[0].FinancialLiterate);
          this.committeeEditForm.controls.accountingOrRelatedFinancialExpertise.setValue(committee.committeeData[0].AccountingOrRelatedFinancialExpertise);
          // this.committeeEditForm.controls.charterFileDocId.setValue(this.CharterFileDocId);
          // this.committeeEditForm.controls.policiesFileDocId.setValue(this.PoliciesFileDocId);

        }
      });

  }



  getCharterDocumentNameByID(doc_id) {
    let OriginalFileName;
    this.documentManagementMasterService.getDocumentManagementById(doc_id)
      .subscribe((documentManagement: any) => {
        this.charterFileDocID = doc_id;
        this.charterFileDocName = documentManagement.documentManagementMasterResult[0].OriginalFileName;
        OriginalFileName = documentManagement.documentManagementMasterResult[0].OriginalFileName;
        // console.log('documentManagement----------->', OriginalFileName);
      });
  }


  getPoliciesDocumentNameByID(doc_id) {
    let OriginalFileName;
    this.documentManagementMasterService.getDocumentManagementById(doc_id)
      .subscribe((documentManagement: any) => {
        this.policiesFileDocID = doc_id;
        this.policiesFileDocName = documentManagement.documentManagementMasterResult[0].OriginalFileName;
        OriginalFileName = documentManagement.documentManagementMasterResult[0].OriginalFileName;
        // console.log('documentManagement----------->', OriginalFileName);
      });

  }



  addPolicyImage() {
    this.charterFileEditFlag = false;
    this.policyFileEditFlag = true;
    $("#charterFileSaveBTN").hide()
    $("#policyFileSaveBTN").show();
    $("#uploadNewFile").modal('show');
  }

  addCharterImage() {
    this.charterFileEditFlag = true;
    this.policyFileEditFlag = false;
    $("#charterFileSaveBTN").show()
    $("#policyFileSaveBTN").hide();
    $("#uploadNewFile").modal('show');
  }



  //For Display Purpose In Table
  getDirectorDetailsListForTable(committeeId) {
    this.allDirectorDetailsForCommittee = [];
    this.invityMember = [];
    this.committeeMember = [];
    var searchParam = {
      dateFrom: this.userSearchDateFrom ? this.setDate(this.userSearchDateFrom) : null,
      dateTo: this.userSearchDateTo ? this.setDate(this.userSearchDateTo) : null,
    }


    this.committeeService.getDirectors(committeeId, searchParam).subscribe(Data => {
      if (Data.status == 0) {
        // console.log(Data.committeeData.committeeData[0].Directors);
        this.allDirectorDetailsForCommittee = Data.committeeData.committeeData[0].Directors;
        this.dtTriggerDirector.next();

        // console.log(Data.committeeData.committeeData[0].Invitees);
        this.invityMember = Data.committeeData.committeeData[0].Invitees;
        this.dtTriggerInvitee.next();

        // console.log(Data.committeeData.committeeData[0].Members);
        this.committeeMember = Data.committeeData.committeeData[0].Members;
        console.log(this.committeeMember)
        this.dtTriggerMember.next();

      }
      this.availableDirectorsID = [];
      for (var i = 0; i < this.allDirectorDetailsForCommittee.length; i++) {
        this.availableDirectorsID[i] = this.allDirectorDetailsForCommittee[i].DirectorID;
      }
      // var length = this.availableDirectorsID.length - 1;
      // for (var i = 0; i < this.invityMember.length; i++) {
      //   this.availableDirectorsID[length+1] = this.invityMember[i].UserGovevaId;
      // }

      console.log('@@@@@@@@@@@@@@@@@@@', this.availableDirectorsID);

    });
  }



  policyfileChangeEvent(fileInput: any) {
    // this.policiesfileArray = <Array<File>>fileInput.target.files;
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.policiesfileArray = <Array<File>>fileInput.target.files;
      this.changefileExtension = true;
    } else {
      this.changefileExtension = false;
    }
  }

  charterfileChangeEvent(fileInput: any) {
    // this.charterfileArray = <Array<File>>fileInput.target.files;
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.charterfileArray = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
    } else {
      this.fileExtension = false;
    }
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        // this.fileOrignalName.push(files[i].name); // for multipule file upload make array of fileOrignalName
        this.fileOrignalName = files[i].name;

        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        // this.fileChangedName.push(newDate + '-' + files[i].name); // for multipule file upload make array of fileChangedName
        this.fileChangedName = newDate + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  upload(fileArray) {
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], fileArray).then((result) => {
      // console.log(result);
    }, (error) => {
      console.error(error);
    });
  }

  uploadCharterFileFromPOPUP() {
    // console.log('----->>', this.charterfileArray);
    if (this.charterfileArray != undefined) {
      // this.upload(this.charterfileArray);
      if (this.charterFileDocID) {
        this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.charterfileArray).then((result) => {
          var documentManagementUpdate = {
            "DocumentManagement":
            {
              _id: this.charterFileDocID,
              DocumentName: this.committeeEditForm.controls.committeeName.value + ' - Committee (Charter File)',
              DateOfDocument: this.setDate(this.committeeEditForm.controls.activationDate.value),
              Upload: this.fileChangedName,
              OriginalFileName: this.fileOrignalName
            }
          }
          this.documentManagementMasterService.updateDocumentOnly(documentManagementUpdate)
            .subscribe((documentManagement: any) => {
              this.charterFileDocID = documentManagement.result._id;
              this.charterFileDocName = documentManagement.result.OriginalFileName;
              this.charterFileIsAvailable = true;
              $(".fileUpload").val("");
              this.charterfileArray = undefined;
              $("#uploadNewFile").modal('hide');
              this.alert.success("Charter file uploaded successfully.");
            });
        }, (error) => {
          this.alert.error(error);
          return false;
        });

      } else {
        this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.charterfileArray).then((result) => {
          var newDocumentManagement = {
            "DocumentManagement":
            {
              Committee_id: this.committeeId,
              Committee_DocType: 'CharterFile',
              DocumentName: this.committeeEditForm.controls.committeeName.value + ' - Committee (Charter File)',
              DateOfDocument: this.setDate(this.committeeEditForm.controls.activationDate.value),
              Upload: this.fileChangedName,
              OriginalFileName: this.fileOrignalName
            }
          }
          this.documentManagementMasterService.updateDocumentOnly(newDocumentManagement)
            .subscribe((documentManagement: any) => {
              this.charterFileDocID = documentManagement.result._id;
              this.charterFileDocName = documentManagement.result.OriginalFileName;
              this.charterFileIsAvailable = true;
              this.charterfileArray = undefined;
              $(".fileUpload").val("");
              $("#uploadNewFile").modal('hide');
              this.alert.success("Charter file uploaded successfully.");
            });
        }, (error) => {
          this.alert.error(error);
          return false;
        });
      }
    } else {
      $("#uploadNewFile").modal('hide');
      this.alert.error("Can not upload empty file.");
    }

    // this.committeeId
  }

  uploadPolicyFileFromPOPUP() {
    // console.log('----->>', this.policiesFileDocID);
    if (this.policiesfileArray) {
      // this.upload(this.policiesfileArray);
      if (this.policiesFileDocID) {
        this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.policiesfileArray).then((result) => {
          var documentManagementUpdate = {
            "DocumentManagement":
            {
              _id: this.policiesFileDocID,
              DocumentName: this.committeeEditForm.controls.committeeAlias.value + ' - Committee (Policy File)',
              DateOfDocument: this.setDate(this.committeeEditForm.controls.activationDate.value),
              Upload: this.fileChangedName,
              OriginalFileName: this.fileOrignalName
            }
          }
          this.documentManagementMasterService.updateDocumentOnly(documentManagementUpdate)
            .subscribe((documentManagement: any) => {
              // console.log(documentManagement);
              this.policiesFileDocID = documentManagement.result._id;
              this.policiesFileDocName = documentManagement.result.OriginalFileName;
              this.policiesFileIsAvailable = true;
              $(".fileUpload").val("");
              this.policiesfileArray = undefined;
              $("#uploadNewFile").modal('hide');
              this.alert.success("Policy file uploaded successfully.");
            });
        }, (error) => {
          this.alert.error(error);
          return false;
        });
      } else {
        this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.policiesfileArray).then((result) => {
          var newDocumentManagement = {
            "DocumentManagement":
            {
              Committee_id: this.committeeId,
              Committee_DocType: 'PoliciesFile',
              DocumentName: this.committeeEditForm.controls.committeeAlias.value + '- Committee (Policy File)',
              DateOfDocument: this.setDate(this.committeeEditForm.controls.activationDate.value),
              Upload: this.fileChangedName,
              OriginalFileName: this.fileOrignalName
            }
          }
          this.documentManagementMasterService.updateDocumentOnly(newDocumentManagement)
            .subscribe((documentManagement: any) => {
              // console.log(documentManagement);
              this.policiesFileDocID = documentManagement.result._id;
              this.policiesFileDocName = documentManagement.result.OriginalFileName;
              this.policiesFileIsAvailable = true;
              this.policiesfileArray = undefined;
              $(".fileUpload").val("");
              $("#uploadNewFile").modal('hide');
              this.alert.success("Policy file uploaded successfully.");
            });
        }, (error) => {
          this.alert.error(error);
          return false;
        });
      }
    } else {
      $("#uploadNewFile").modal('hide');
      this.alert.error("Can not upload empty file.");
    }
  }



  loadModelForAddDirector() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#directorDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#directorDialog').modal('show');
    }, 100);
    this.editActive = false;
    this.update = false;
    this.directorIsNotValid = false;
    this.directorForm.controls.CessationDate.setValue(null);
    this.directorForm.reset();
    this.directorForm.controls.DirectorDIN.setValue("null");
    $('#DirectorLabel').html("<i class='fa fa-plus'></i>Director Details :");
    $("#btnUpdateDirectorRow").hide();
    $("#btnaddDirectorRow").show();
    this.directorData = []
    // this.getDirectorsDIN();
  }


  getDirectorsDIN() {
    console.log('without edit')
    var actualdDataToShow = [];
    this.directorData = [];
    this.committeeService.getActiveDirectorForCommitte(this.committeeId).subscribe(director => {
      if (director.status == 0) {
        this.directorData = director.directorList;
        var length = this.availableDirectorsID.length > 0 ? this.availableDirectorsID.length - 1 : 0;
        for (var k = 0; k < this.invityMember.length; k++) {
          this.availableDirectorsID[length + 1] = this.invityMember[k].UserGovevaId;
        }
        var availDIR = this.availableDirectorsID
        //  console.log('In Table',  this.directorData);
        // console.log('availDIR',availDIR);
        for (var i = 0; i < this.directorData.length; i++) {
          var found = false;
          for (var j = 0; j < availDIR.length; j++) {
            if (availDIR[j] == this.directorData[i]._id && availDIR[j] != undefined) {
              //  console.log('availDIR Found', this.directorData[i]._id);
              found = true;
            }
          }
          if (!found) {
            actualdDataToShow.push(this.directorData[i]);
          }
        }
      }
      this.directorData = actualdDataToShow;

      this.directorData = this.commonFunction.sortByKey(this.directorData, 'FirstName');
      // console.log('directorData-->', this.directorData);
    });
  }

  getDirectorsDINOnEdit(selectedDirector, type) {
    console.log('with edit')
    console.log('In Table', selectedDirector);
    var actualdDataToShow = [];
    // this.directorData = [];
    if (type == 'Director') {
      this.directorService.getDirectorMember().subscribe(director => {
        if (director.status == 0) {
          this.directorData = director.directorList;
          // var length = this.directorData.length;
          if (this.directorData.length > 0) {
            var availDIR = this.availableDirectorsID
            // this.directorData = this.directorData.concat(this.allMembers);
            //  console.log('availDIR', this.directorData);
            for (var i = 0; i < this.directorData.length; i++) {
              var found = false;
              for (var j = 0; j < availDIR.length; j++) {
                if (availDIR[j] == this.directorData[i]._id && selectedDirector.DirectorID != this.directorData[i]._id && availDIR[j] != undefined) {
                  //  console.log('availDIR Found', this.directorData[i]._id);
                  found = true;
                }

              }
              if (this.directorData[i].DirectorProfession.length > 0 && !found) {
                actualdDataToShow.push(this.directorData[i]);
              }
            }
          }
        }
        this.directorData = actualdDataToShow;
        this.directorData = this.commonFunction.sortByKey(this.directorData, 'FirstName');
        console.log('directorData-->', this.directorData);
      });
    } else if (type == 'Member') {
      this.membersListFromGovEva = [];
      this.directorData = [];
      this.committeeService.getMembersFromGoveva().subscribe(members => {
        if (members.status == 0) {
          this.membersListFromGovEva = members.userList
          this.allMembers = members.userList;
          var mem = this.membersListFromGovEva.findIndex(x => x.EmailId == selectedDirector.EmailId);
          var filteredMem = this.membersListFromGovEva[mem];
          selectedDirector.FirstName = filteredMem.FirstName;
          selectedDirector.LastName = filteredMem.LastName;
          this.membersListFromGovEva.forEach(element => {
            element.IsSelected = false;
          });
          var other = _.concat(this.committeeMember, this.invityMember);
          var ids = new Set(other.map(({ EmailId }) => EmailId));
          this.membersListFromGovEva = this.membersListFromGovEva.filter(({ EmailId }) => !ids.has(EmailId));
          this.membersListFromGovEva.push(selectedDirector);
        } else {
          this.membersListFromGovEva = []
        }
        this.dtTriggerMemberAddingPopup.next();
        console.log(this.membersListFromGovEva);
        this.directorData = this.membersListFromGovEva;
      })
    }
    // this.directorService.getDirectorMember().subscribe(director => {
    //   if (director.status == 0) {
    //     this.directorData = director.directorList;
    //     var length = this.directorData.length;
    //     var availDIR = this.availableDirectorsID
    //     this.directorData = this.directorData.concat(this.allMembers);
    //     //  console.log('availDIR', this.directorData);
    //     for (var i = 0; i < this.directorData.length; i++) {
    //       var found = false;
    //       for (var j = 0; j < availDIR.length; j++) {
    //         if (availDIR[j] == this.directorData[i]._id && selectedDirector.DirectorID != this.directorData[i]._id && availDIR[j] != undefined) {
    //           //  console.log('availDIR Found', this.directorData[i]._id);
    //           found = true;
    //         }

    //       }
    //       if (this.directorData[i].DirectorProfession.length > 0 && !found) {
    //         actualdDataToShow.push(this.directorData[i]);
    //       }
    //     }
    //   }
    //   this.directorData = actualdDataToShow;
    //   this.directorData = this.commonFunction.sortByKey(this.directorData, 'FirstName');
    //   console.log('directorData-->', this.directorData);
    // });
  }


  getDirectorDetails(ev, type) {

    // console.log(this.maxdateOfApp,'<-------------MAx app date');
    console.log(this.directorForm.controls.DirectorID.value)
    console.log(ev.target.value)
    var dinID = ev.target.value;

    // if (dinID == null || dinID == undefined || dinID == 'null') {
    //   this.directorForm.reset();
    // } else {
    if (type == 'Director') {
      console.log(type);
      this.directorData.forEach(element => {
        if (element._id == dinID) {
          // console.log('element-->>',element.DirectorProfession[0]);
          if (element.DirectorProfession[0] == undefined) {
            this.directorIsNotValid = true;
            this.directorForm.controls.DirectorID.setValue(element._id);
            this.directorForm.controls.DirectorDIN.setValue(element.Din);
            // this.directorForm.controls.Chairman.setValue(element.DirectorProfession[0].IsChairman=="true" ? "Chairman" : "-");
            this.directorForm.controls.MemberName.setValue(element.FirstName + ' ' + element.MiddleName + ' ' + element.LastName);
            this.directorForm.controls.Designation.setValue(null);
            this.directorForm.controls.Category.setValue(null);
            this.directorForm.controls.IsExecutive.setValue(null);
            console.log(element.EmailID);
            this.directorForm.controls.EmailID.setValue(element.EmailID);
            this.directorGovEvaID = element.GovevaUserId;
            this.directorForm.controls.GovEvaUserDesignation.setValue(null);
          } else {
            this.directorIsNotValid = false;
            this.directorForm.controls.DirectorID.setValue(element._id);
            this.directorForm.controls.DirectorDIN.setValue(element.Din);
            // this.directorForm.controls.Chairman.setValue(element.DirectorProfession[0].IsChairman=="true" ? "Chairman" : "-");
            this.directorForm.controls.MemberName.setValue(element.FirstName + ' ' + element.MiddleName + ' ' + element.LastName);
            this.directorForm.controls.Designation.setValue(element.DirectorProfession[0].Designation);
            this.directorForm.controls.Category.setValue(element.DirectorProfession[0].Category);
            this.directorForm.controls.IsExecutive.setValue(element.DirectorProfession[0].IsExecutive ? "Executive" : "Non-Executive");
            this.directorGovEvaID = element.GovevaUserId;
            this.directorForm.controls.GovEvaUserDesignation.setValue(element.DirectorProfession[0].Designation);
            console.log(element.EmailID);
            this.directorForm.controls.EmailID.setValue(element.EmailID);
            if (moment(this.activationDateOfCommittee).format('YYYY-MM-DD') > moment(element.DirectorProfession[0].AppointmentDate).format('YYYY-MM-DD')) {
              // console.log('committee formation is bigger',moment(this.activationDateOfCommittee).format('YYYY-MM-DD'),'---',moment(element.DirectorProfession[0].AppointmentDate).format('YYYY-MM-DD') );

              let dt = new Date(this.setFormatDate(this.activationDateOfCommittee));
              // this.CompletedDateModel = ;
              // this.committeeEditForm.controls.activationDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
              this.maxdateOfApp = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };


            } else {
              // console.log('Appointment date is bigger',moment(this.activationDateOfCommittee).format('YYYY-MM-DD'),'---',moment(element.DirectorProfession[0].AppointmentDate).format('YYYY-MM-DD'));

              let dt = new Date(this.setFormatDate(element.DirectorProfession[0].AppointmentDate));
              // this.CompletedDateModel = ;
              // this.committeeEditForm.controls.activationDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
              this.maxdateOfApp = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };

            }

          }

        }
      });
    } else if (type == 'Member') {
      var mem = this.directorData.findIndex(x => x._id == dinID);
      console.log(mem);
      var data = this.directorData[mem];
      this.directorForm.controls.DirectorID.setValue(data._id);
      this.directorForm.controls.DirectorDIN.setValue(null);
      // this.directorForm.controls.Chairman.setValue(element.DirectorProfession[0].IsChairman=="true" ? "Chairman" : "-");
      this.directorForm.controls.MemberName.setValue(data.FirstName + ' ' + data.LastName);
      console.log(this.directorForm.controls.MemberName.value);
      this.directorForm.controls.Designation.setValue('Member');
      this.directorForm.controls.Category.setValue(null);
      this.directorForm.controls.IsExecutive.setValue(null);
      this.directorForm.controls.EmailID.setValue(data.EmailId);
      this.directorGovEvaID = data.UserGovevaId;
      this.directorForm.controls.GovEvaUserDesignation.setValue(data.Designation);
    }
    //  }


  }


  /*  
   *Update Committee Data
   */
  editCommittee() {
    this.disabledOnclick = true;
    if (this.committeeEditForm.controls.committeeName.value == 'Other') {
      if (this.committeeEditForm.controls.otherCommitteeName.value == "" || this.committeeEditForm.controls.otherCommitteeName.value == null) {
        this.isOtherNotValid = true;
        return false;
      } else {
        this.isOtherNotValid = false;
      }
    }
    let charterFileIsAvailable = false;
    let policiesFileIsAvailable = false;
    let charterFileChangedName = null;
    let charterFileOrignalName = null;
    let policiesFileChangedName = null;
    let policiesFileOrignalName = null;
    if (this.committeeEditForm.status == 'VALID') {
      var newcommittee = {
        _id: this.committeeId,
        committeeName: this.committeeEditForm.controls.committeeName.value,
        otherCommitteeName: this.committeeEditForm.controls.otherCommitteeName.value,
        committeeAlias: this.committeeEditForm.controls.committeeAlias.value,
        CommitteeShortName: this.committeeEditForm.controls.CommitteeShortName.value,
        meetingFrequency: this.committeeEditForm.controls.meetingFrequency.value,
        meetingGap: this.committeeEditForm.controls.meetingGap.value,
        quorumDirectors: this.committeeEditForm.controls.quorumDirectors.value,
        meetingNoticePeriod: this.committeeEditForm.controls.meetingNoticePeriod.value,
        statutoryCommittee: this.committeeEditForm.controls.statutoryCommittee.value,
        activationDate: this.setDate(this.committeeEditForm.controls.activationDate.value),
        sittingFees: this.committeeEditForm.controls.sittingFees.value,
        financialLiterate: this.committeeEditForm.controls.financialLiterate.value,
        accountingOrRelatedFinancialExpertise: this.committeeEditForm.controls.accountingOrRelatedFinancialExpertise.value,
        CreatedBy: null,
        ModifiedBy: null,
        ModifiedDate: new Date(),
      }
      this.committeeService.editCommittee(newcommittee)
        .subscribe(commitee => {
          this.disabledOnclick = false;
          if (commitee.status == 0) {
            this.alert.successWithOk1(commitee.message, () => {
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['committee'] } }],
                { relativeTo: this.route.parent });
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
            });

          }
          else {
            if (commitee.err_fields != undefined && commitee.err_fields != "") {
              this.alert.error(JSON.stringify(commitee.err_fields) + ' fields are required or invalid.');
            } else {
              this.alert.error(commitee.message);
            }

          }
        });
    } else {
      this.disabledOnclick = false;
      return false;
    }

  }//update committee



  saveDirectors() {
    this.disabledOnclick = true;
    console.log(this.directorForm.valid);
    console.log(this.directorForm.controls.MemberType.value)
    if (this.directorForm.valid) {
      if (this.directorForm.controls.MemberType.value == 'Director') {
        var directorToUPdateInCommittee = {
          _id: this.committeeId,
          DirectorDIN: this.directorForm.controls.DirectorDIN.value,
          MemberName: this.directorForm.controls.MemberName.value,
          Designation: this.directorForm.controls.Designation.value,
          Category: this.directorForm.controls.Category.value,
          IsExecutive: this.directorForm.controls.IsExecutive.value,
          Chairman: this.directorForm.controls.Chairman.value,
          AppointmentDate: this.setDate(this.directorForm.controls.AppointmentDate.value),
          //Tenure: this.directorForm.controls.Tenure.value,
          Tenure: this.commonFunction.setDate(this.directorForm.controls.Tenure.value),
          CessationDate: this.setDate(this.directorForm.controls.CessationDate.value),
          CessationReason: this.directorForm.controls.CessationReason.value,
          DirectorID: this.directorForm.controls.DirectorID.value,
          UserGovevaId: this.directorGovEvaID,
          financialLiterate: this.directorForm.controls.financialLiterate.value,
          accountingOrRelatedFinancialExpertise: this.directorForm.controls.accountingOrRelatedFinancialExpertise.value,
          EmailID: this.directorForm.controls.EmailID.value,
          GovEvaUserDesignation: this.directorForm.controls.GovEvaUserDesignation.value
        }
        console.log('Payload being sent:', directorToUPdateInCommittee);
        this.committeeService.addCommitteeDirector(directorToUPdateInCommittee, this.committeeId)
          .subscribe(
            (members: any) => {
              console.log('Response from addCommitteeDirector:', members); // <-- Add this

              this.disabledOnclick = false;

              if (members.status === 0) {
                $('#directorDialog').modal('hide');
                this.alert.successWithOk1(members.message, () => {
                    $('#directorDialog').off('hidden.bs.modal');
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                    this.directorForm.reset();
                    this.disabledOnclick = false;

                      this.router.navigate(
                        [{ outlets: { 'structure-outlet': ['committee', 'edit', this.committeeId] } }],
                        { relativeTo: this.route.parent });
                })
                this.refreshTableOnTabClick(""); // <-- Make sure this reloads the table
                this.directorForm.reset();
              } else {
                $('#directorDialog').modal('hide');
                this.alert.error1(members.message || 'Unknown error occurred.', () => {
                  $('#directorDialog').off('hidden.bs.modal');
                  $('.modal-backdrop').remove();
                  $('body').removeClass('modal-open');

                  // Optional: reset form if needed
                  this.directorForm.reset();

                  // Optional: reset your flags
                  this.disabledOnclick = false;
                });
              }
            },
            (err) => {
              this.disabledOnclick = false;
              this.alert.error1('Failed to add director. Please try again.', () => {
                $('#error-alert2').modal('hide');
                $('.modal').modal('hide');
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
                $('body').css('padding-right', ''); // removes BS padding added on modal open

                // Optional: reset form if needed
                this.directorForm.reset();

                // Optional: reset your flags
                this.disabledOnclick = false;
              });
            }
          );
      } else if (this.directorForm.controls.MemberType.value == 'Member') {
        this.saveMember();
        // Optional: reset form if needed
        this.directorForm.reset();

        // Optional: reset your flags
        this.disabledOnclick = false;
      } else if (this.directorForm.controls.MemberType.value == 'Member') {
        this.saveMember();
        $('.modal').modal('hide');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        $('body').css('padding-right', ''); // removes BS padding added on modal open

        // Optional: reset form if needed
        this.directorForm.reset();

        // Optional: reset your flags
        this.disabledOnclick = false;
      }


    } else {
      $('#directorDialog').off('hidden.bs.modal');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('#directorDialog').modal('hide');
      this.disabledOnclick = false;
      return false
    }

  }

  alreadyExist: boolean = false;
  saveInvitee() {
    this.disabledOnclick = true;
    if (this.inviteeForm.valid) {
      var invityFormMember = {
        InviteeName: this.inviteeForm.controls.InviteeName.value,
        Designation: this.inviteeForm.controls.Designation.value,
        Address: this.inviteeForm.controls.Address.value,
        City: this.inviteeForm.controls.City.value,
        State: this.inviteeForm.controls.State.value,
        TelO: this.inviteeForm.controls.TelO.value,
        TelR: this.inviteeForm.controls.TelR.value,
        FaxNo: this.inviteeForm.controls.FaxNo.value,
        MobileNo: this.inviteeForm.controls.MobileNo.value,
        EmailId: this.inviteeForm.controls.EmailId.value,
        InAttendance: this.inviteeForm.controls.InAttendance.value,
        ThroughVC: this.inviteeForm.controls.ThroughVC.value,
        GovevaUserId: null
      }
      var existingInvity = [];

      this.committeeMember.forEach(function (item) {
        if (item.EmailId == invityFormMember.EmailId) {
          existingInvity.push(item);
        }
      })
      this.invityMember.forEach(function (item) {
        if (item.EmailId == invityFormMember.EmailId) {
          existingInvity.push(item);
        }
      })
      if (existingInvity.length) {
        this.alreadyExist = true;
      } else {
        this.alreadyExist = false;
        this.committeeService.addCommitteeInvitee(invityFormMember, this.committeeId)
          .subscribe(members => {
            this.disabledOnclick = false;
            $("#inviteeDialog").modal('toggle');
            if (members.status == 0) {
              this.alert.successWithOk(members.message, 'committee/edit/' + this.committeeId);
              // $("#inviteeTable").DataTable().destroy();
              this.refreshTableOnTabClick("inviteeTable")
              // if (this.dtElementInvitee.dtInstance != undefined) {
              //   this.dtElementInvitee.dtInstance.then((dtInstance: DataTables.Api) => {
              //     dtInstance.destroy();
              //   });
              // }

              this.inviteeForm.reset();
              //this.getDirectorDetailsListForTable(this.committeeId)
            }
            else {
              if (members.err_fields != undefined && members.err_fields != "") {
                this.alert.error(JSON.stringify(members.err_fields) + ' fields are required or invalid.');
              } else {
                this.alert.error(members.message);
              }


            }
          });
      }

    } else {
      this.disabledOnclick = false;
      return false
    }

  }

  indexOfMemberElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      if (o.EmailId == elementValue.EmailId) { }
      return o.EmailId == elementValue.EmailId;
    })
    return index;
  }


  getMembersFromGoveva() {
    $("#memberTablePopup").DataTable().destroy();
    this.membersListFromGovEva = [];

    this.committeeService.getMembersFromGoveva().subscribe(members => {
      if (members.status == 0) {
        this.membersListFromGovEva = members.userList
        this.allMembers = members.userList;
        this.membersListFromGovEva.forEach(element => {
          element.IsSelected = false;
        });

        // var checkedMembers = this.membersListFromGovEva.filter(opt => opt.IsSelected).map(opt => opt);
        // console.log(checkedMembers);
        // var addedMember = this.committeeMember;
        // var allMember = this.membersListFromGovEva;
        // addedMember.concat(this.invityMember)
        var other = _.concat(this.committeeMember, this.invityMember);


        var ids = new Set(other.map(({ EmailId }) => EmailId));

        this.membersListFromGovEva = this.membersListFromGovEva.filter(({ EmailId }) => !ids.has(EmailId));

        //  console.log("allMember", allMember);
        //   console.log("other", other);
        // for (var j = 0; j < other.length; j++) {
        //   var index = this.indexOfSelectedMemberElementArray(allMember, other[j]);
        //   // console.log(index);
        //   allMember.splice(index, 1);
        // }



      } else {
        // console.log('error in goveva to fetch members (users-Non Director Members)');
        this.membersListFromGovEva = []
      }
      this.dtTriggerMemberAddingPopup.next();
      console.log(this.membersListFromGovEva);
      this.directorData = this.membersListFromGovEva;
    })

  }

  saveMember() {
    //    if (this.memberForm.valid) {
    var memberFormMember = {
      MemberName: this.directorForm.controls.MemberName.value,
      Designation: this.directorForm.controls.Designation.value,
      Chairman: this.directorForm.controls.Chairman.value,
      // Address: this.memberForm.controls.Address.value,
      // City: this.memberForm.controls.City.value,
      // State: this.memberForm.controls.State.value,
      // TelO: this.memberForm.controls.TelO.value,
      // TelR: this.memberForm.controls.TelR.value,
      // FaxNo: this.memberForm.controls.FaxNo.value,
      // MobileNo: this.memberForm.controls.MobileNo.value,
      EmailId: this.directorForm.controls.EmailID.value,
      AppointmentDate: this.setDate(this.directorForm.controls.AppointmentDate.value),
      Tenure: this.commonFunction.setDate(this.directorForm.controls.Tenure.value),
      CessationDate: this.setDate(this.directorForm.controls.CessationDate.value),
      CessationReason: this.directorForm.controls.CessationReason.value,
      FinancialLiterate: this.directorForm.controls.financialLiterate.value,
      AccountingOrRelatedFinancialExpertise: this.directorForm.controls.accountingOrRelatedFinancialExpertise.value,
      UserGovevaId: this.directorGovEvaID,
      GovEvaUserDesignation: this.directorForm.controls.GovEvaUserDesignation.value
    }

    // console.log(memberFormMember);
    var existingInvity = [];
    this.committeeMember.forEach(function (item) {
      if (item.EmailId == memberFormMember.EmailId) {
        existingInvity.push(item);
      }
    })
    this.invityMember.forEach(function (item) {
      if (item.EmailId == memberFormMember.EmailId) {
        existingInvity.push(item);
      }
    })
    if (existingInvity.length) {
      this.alreadyExist = true;
    } else {
      this.alreadyExist = false;
      this.committeeService.addCommitteeMember(memberFormMember, this.committeeId)
        .subscribe((members: any) => {
          this.disabledOnclick = false;
          //    $("#memberDialog").modal('toggle');
          $("#directorDialog").modal('hide');
          if (members.status == 0) {

            this.alert.successWithOk1(members.message, () => {
              // this.router.navigate(
              //   [{ outlets: { 'structure-outlet': ['committee'] } }],
              //   { relativeTo: this.route.parent });
                $('#directorDialog').off('hidden.bs.modal');   
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            });

            this.memberForm.reset();
            this.refreshTableOnTabClick('')

          }
          else {
            if (members.err_fields != undefined && members.err_fields != "") {
              this.alert.error(JSON.stringify(members.err_fields) + ' fields are required or invalid.');
            } else {
              this.alert.error(members.message);
            }

          }
        });
    }

    // } else {

    //   // return false;
    //   $("#memberTablePopup").DataTable().destroy();
    //   var checkedMembers = this.membersListFromGovEva.filter(opt => opt.IsSelected).map(opt => opt);
    //   // console.log(checkedMembers);
    //   var addedMember = this.committeeMember;
    //   var allMember = this.membersListFromGovEva;

    //   for (var j = 0; j < checkedMembers.length; j++) {
    //     var index = this.indexOfSelectedMemberElementArray(allMember, checkedMembers[j]);
    //     // console.log(index);
    //     allMember.splice(index, 1);
    //   }
    //   //  console.log(checkedMembers);
    //   this.committeeService.addCommitteeGovevaMember(checkedMembers, this.committeeId)
    //     .subscribe(members => {
    //       $("#memberDialog").modal('toggle');
    //       if (members.status == 0) {
    //         this.alert.successWithOk(members.message, 'committee/edit/' + this.committeeId);
    //         this.refreshTableOnTabClick('memberTable')
    //         this.dtTriggerMemberAddingPopup.next();
    //       }
    //     })
    // }
  }

  indexOfSelectedMemberElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      if (o.EmailId != elementValue.EmailId) { }
      return o.EmailId != elementValue.EmailId;
    })
    return index;
  }

  // indexOfElementArrayEmail(array: any[], elementValue) {
  //   var index = _.differenceWith(array, function (o:any[]) {

  //     if (o.EmailId != elementValue.EmailId) { }
  //     return o.EmailId != elementValue.EmailId;
  //   })
  //   return index;
  // }

  indexOfElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {

      if (o._id == elementValue._id) { }
      return o._id == elementValue._id;
    })
    return index;
  }

  selectAllMembers(ev) {
    if (ev.target.checked == true) {
      this.membersListFromGovEva.forEach(element => {
        element.IsSelected = true;
      });

      this.membersListFromGovEva.forEach(element => {
        if (element.IsSelected == true) {
          this.hideMemberBtn = false;
        }
      });

    } else {
      this.membersListFromGovEva.forEach(element => {
        element.IsSelected = false;
      });
      this.hideMemberBtn = true;
    }

  }


  checkMemberselected(event) {
    // console.log(event.target);
    if (event.target.checked == true) {
      //console.log(event.target);
      this.isMemberSelected = true;
    }
    else {
      this.isMemberSelected = false;
    }
    var checkedMembers = this.membersListFromGovEva.filter(opt => opt.IsSelected).map(opt => opt);
    // console.log(checkedMembers.length);
    if (checkedMembers.length == 0) {
      this.hideMemberBtn = true;
    } else {
      this.hideMemberBtn = false;
    }
  }


  loadToEditDirector(director) {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#directorDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#directorDialog').modal('show');
      $('#DirectorLabel').html("<i class='fa fa-pencil'></i>Director Details :");
    }, 100);

    // this.getDirectorsDIN();
    this.editActive = true;
    this.update = true;
    this.directorForm.controls.MemberType.setValue(director.userType);
    //  this.getUserByType(director.userType);
    this.getDirectorsDINOnEdit(director, director.userType);
    let dt1;
    this.dir_id = director._id;
    // _id: this.committeeId,
    dt1 = new Date(this.setFormatDate(director.AppointmentDate));
    this.directorForm.controls.AppointmentDate.setValue({ month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() }),

      this.directorData.push(director);
    this.directorForm.controls.DirectorDIN.setValue(director.DirectorDIN);
    this.directorForm.controls.Designation.setValue(director.Designation);
    this.directorForm.controls.Category.setValue(director.Category);
    this.directorGovEvaID = director.UserGovevaId;
    if (director.IsExecutive == "Executive" || director.IsExecutive == "true" || director.IsExecutive == true) { this.directorForm.controls.IsExecutive.setValue("Executive"); } else { this.directorForm.controls.IsExecutive.setValue("Non-Executive"); }


    if (director.Tenure != null) {
      let dtTenure = new Date(this.setFormatDate(director.Tenure));
      this.directorForm.controls.Tenure.setValue({ month: dtTenure.getMonth() + 1, day: dtTenure.getDate(), year: dtTenure.getFullYear() });
    }
    else {
      this.directorForm.controls.Tenure.setValue(null);
    }

    //this.directorForm.controls.Tenure.setValue(director.Tenure);

    if (director.CessationDate == null) {
      this.directorForm.controls.CessationDate.setValue(null);
    } else {
      dt1 = new Date(this.setFormatDate(director.CessationDate));
      this.directorForm.controls.CessationDate.setValue({ month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() });
    }

    this.directorForm.controls.CessationReason.setValue(director.CessationReason);
    this.directorForm.controls.Chairman.setValue(director.Chairman);
    this.directorForm.controls.financialLiterate.setValue(director.FinancialLiterate);
    this.directorForm.controls.accountingOrRelatedFinancialExpertise.setValue(director.AccountingOrRelatedFinancialExpertise);
    if (director.userType == 'Director') {
      this.directorForm.controls.DirectorID.setValue(director.DirectorID);
      this.directorForm.controls.MemberName.setValue(director.DirectorName);
      this.directorForm.controls.EmailID.setValue(director.EmailID);
    } else if (director.userType == 'Member') {
      this.directorForm.controls.DirectorID.setValue(director._id);
      this.directorForm.controls.MemberName.setValue(director.MemberName);
      this.directorForm.controls.EmailID.setValue(director.EmailId);
    }
    this.directorForm.markAllAsTouched();
    this.directorForm.updateValueAndValidity();
  }

  loadToEditInvitee(invitee) {
    this.checkEmailIdExistInInvitee = false;

    this.inviteeForm.controls.InviteeName.enable();
    this.inviteeForm.controls.Designation.enable();
    this.inviteeForm.controls.MobileNo.enable();
    this.inviteeForm.controls.EmailId.enable();

    this.invitee_id = invitee._id;
    this.inviteeForm.controls.InviteeName.setValue(invitee.InviteeName);
    this.inviteeForm.controls.Address.setValue(invitee.Address);
    this.inviteeForm.controls.Designation.setValue(invitee.Designation);
    this.inviteeForm.controls.City.setValue(invitee.City);
    this.inviteeForm.controls.State.setValue(invitee.State);
    this.inviteeForm.controls.TelO.setValue(invitee.TelO);
    this.inviteeForm.controls.TelR.setValue(invitee.TelR);
    this.inviteeForm.controls.FaxNo.setValue(invitee.FaxNo);
    this.inviteeForm.controls.MobileNo.setValue(invitee.MobileNo);
    this.inviteeForm.controls.EmailId.setValue(invitee.EmailId);
    this.inviteeForm.controls.InAttendance.setValue(invitee.InAttendance);
    this.inviteeForm.controls.ThroughVC.setValue(invitee.ThroughVC);
    $("#btnUpdateInviteeRow").show();
    $("#btnaddInviteeRow").hide();
    $('#InviteeLabel').html("<i class='fa fa-pencil'></i>Invitee Details :");
    $("#inviteeDialog").modal('toggle');
  }

  loadToEditMember(Member) {
    this.member_id = Member._id;
    // console.log(Member);
    this.memberForm.controls.MemberName.setValue(Member.MemberName);
    this.memberForm.controls.Address.setValue(Member.Address);
    this.memberForm.controls.Designation.setValue(Member.Designation);
    this.memberForm.controls.City.setValue(Member.City);
    this.memberForm.controls.State.setValue(Member.State);
    this.memberForm.controls.TelO.setValue(Member.TelO);
    this.memberForm.controls.TelR.setValue(Member.TelR);
    this.memberForm.controls.FaxNo.setValue(Member.FaxNo);
    this.memberForm.controls.MobileNo.setValue(Member.MobileNo);
    this.memberForm.controls.EmailId.setValue(Member.EmailId);
    this.memberForm.controls.Chairman.setValue(Member.Chairman);

    let dt1 = new Date(this.setFormatDate(Member.AppointmentDate));
    this.memberForm.controls.AppointmentDate.setValue({ month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() }),
      this.memberForm.controls.Tenure.setValue(Member.Tenure);

    if (Member.CessationDate == null) {
      this.memberForm.controls.CessationDate.setValue(null);
    } else {
      dt1 = new Date(this.setFormatDate(Member.CessationDate));
      this.memberForm.controls.CessationDate.setValue({ month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() });
    }
    this.memberForm.controls.CessationReason.setValue(Member.CessationReason);
    this.memberForm.controls.financialLiterate.setValue(Member.FinancialLiterate);
    this.memberForm.controls.accountingOrRelatedFinancialExpertise.setValue(Member.AccountingOrRelatedFinancialExpertise);
    $("#btnUpdateMemberRow").show();
    $("#btnaddMemberRow").hide();
    $('#MemberLabel').html("<i class='fa fa-pencil'></i>Member Details :");
    $("#memberDialog").modal('toggle');

  }

  updateUser(type) {
    this.disabledOnclick = true;
    console.log(type)
    if (type == 'Director') {
      this.updateDirectors();
    } else if (type == 'Member') {
      this.updateMember();
    }
    $('#committeeDetailsTab').trigger('click');
  }
  updateDirectors() {
    if (this.directorForm.valid) {

      var directorToUPdateInCommittee = {
        _id: this.committeeId,
        Director_id: this.dir_id,
        DirectorDIN: this.directorForm.controls.DirectorDIN.value,
        MemberName: this.directorForm.controls.MemberName.value,
        Designation: this.directorForm.controls.Designation.value,
        Category: this.directorForm.controls.Category.value,
        IsExecutive: this.directorForm.controls.IsExecutive.value,
        Chairman: this.directorForm.controls.Chairman.value,
        AppointmentDate: this.setDate(this.directorForm.controls.AppointmentDate.value),
        //Tenure: this.directorForm.controls.Tenure.value,
        Tenure: this.commonFunction.setDate(this.directorForm.controls.Tenure.value),
        CessationDate: this.setDate(this.directorForm.controls.CessationDate.value),
        CessationReason: this.directorForm.controls.CessationReason.value,
        DirectorID: this.directorForm.controls.DirectorID.value,
        UserGovevaId: this.directorGovEvaID,
        FinancialLiterate: this.directorForm.controls.financialLiterate.value,
        AccountingOrRelatedFinancialExpertise: this.directorForm.controls.accountingOrRelatedFinancialExpertise.value,
        EmailID: this.directorForm.controls.EmailID.value
      }
      // console.log(directorToUPdateInCommittee, this.committeeId, this.dir_id);
      this.committeeService.updateCommitteeDirector(directorToUPdateInCommittee, this.committeeId, this.dir_id)
        .subscribe((members: any) => {
          this.disabledOnclick = false;
          $("#directorDialog").modal('hide');
          if (members.status == 0) {
            // console.log(members);
            this.alert.successWithOk1(members.message, () => {
              $('#directorDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['committee', 'edit', this.committeeId] } }],
                { relativeTo: this.route.parent });
              if (this.dtElementMember.dtInstance != undefined) {
                this.dtElementMember.dtInstance.then((dtInstance: DataTables.Api) => {
                  dtInstance.destroy();
                });
              }
              $("#memberTable").DataTable().destroy();
              this.directorForm.reset();

              this.refreshTableOnTabClick("")

            });



            this.getDirectorDetailsListForTable(this.committeeId)
          }
          else {
            if (members.err_fields != undefined && members.err_fields != "") {
              this.alert.error(JSON.stringify(members.err_fields) + ' fields are required or invalid.');
            } else {
              this.alert.error(members.message);
            }
          }
        });

    } else {
      this.disabledOnclick = false;
      return false
    }

  }


  updateInvitee() {
    this.disabledOnclick = true;
    if (this.inviteeForm.valid) {
      var invityFormMember = {
        Invitee_id: this.invitee_id,
        InviteeName: this.inviteeForm.controls.InviteeName.value,
        Designation: this.inviteeForm.controls.Designation.value,
        Address: this.inviteeForm.controls.Address.value,
        City: this.inviteeForm.controls.City.value,
        State: this.inviteeForm.controls.State.value,
        TelO: this.inviteeForm.controls.TelO.value,
        TelR: this.inviteeForm.controls.TelR.value,
        FaxNo: this.inviteeForm.controls.FaxNo.value,
        MobileNo: this.inviteeForm.controls.MobileNo.value,
        EmailId: this.inviteeForm.controls.EmailId.value,
        InAttendance: this.inviteeForm.controls.InAttendance.value,
        ThroughVC: this.inviteeForm.controls.ThroughVC.value
      }

      var existingInvity = [];
      var checkInviteeEmailExist = _.concat(this.committeeMember, this.invityMember);
      checkInviteeEmailExist.forEach(function (element) {
        if (invityFormMember.Invitee_id != element._id && element.EmailId == invityFormMember.EmailId) {
          existingInvity.push(element);
        }
      });
      if (existingInvity.length) {
        this.checkEmailIdExistInInvitee = true;
      } else {
        this.checkEmailIdExistInInvitee = false;
        // console.log(invityFormMember);
        this.committeeService.updateCommitteeInvitee(invityFormMember, this.committeeId, this.invitee_id)
          .subscribe((members: any) => {
            this.disabledOnclick = false;
            if (members.status == 0) {
              $('#inviteeDialog').modal('hide')
              $('#existingInviteeDialog').modal('hide');
              this.alert.successWithOk1(members.message, () => {
                this.router.navigate(
                  [{ outlets: { 'structure-outlet': ['committee', 'edit', this.committeeId] } }],
                  { relativeTo: this.route.parent });
                $('#inviteeDialog').off('hidden.bs.modal');
                $('#existingInviteeDialog').off('hidden.bs.modal');
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');

              });
              if (this.dtElementInvitee.dtInstance != undefined) {
                this.dtElementInvitee.dtInstance.then((dtInstance: DataTables.Api) => {
                  dtInstance.destroy();
                });
              }
              this.inviteeForm.reset();
              // $("#inviteeTable").DataTable().destroy();
              this.refreshTableOnTabClick("inviteeTable");
              // this.getDirectorDetailsListForTable(this.committeeId)
            }
            else {
              if (members.err_fields != undefined && members.err_fields != "") {
                this.alert.error(JSON.stringify(members.err_fields) + ' fields are required or invalid.');
              } else {
                this.alert.error(members.message);
              }
            }
          });
      }

    } else {
      this.disabledOnclick = false;
      return false
    }

  }


  updateMember() {
    const memberFormMember = {
      Member_id: this.dir_id,
      MemberName: this.directorForm.controls.MemberName.value,
      Designation: this.directorForm.controls.Designation.value,
      EmailId: this.directorForm.controls.EmailID.value,
      Chairman: this.directorForm.controls.Chairman.value,
      AppointmentDate: this.setDate(this.directorForm.controls.AppointmentDate.value),
      Tenure: this.commonFunction.setDate(this.directorForm.controls.Tenure.value),
      CessationDate: this.setDate(this.directorForm.controls.CessationDate.value),
      CessationReason: this.directorForm.controls.CessationReason.value,
      FinancialLiterate: this.directorForm.controls.financialLiterate.value,
      AccountingOrRelatedFinancialExpertise: this.directorForm.controls.accountingOrRelatedFinancialExpertise.value,
      UserGovevaId: this.directorGovEvaID
    };
  
    this.committeeService.updateCommitteeMember(memberFormMember, this.committeeId, this.dir_id)
      .subscribe((members: any) => {
        this.disabledOnclick = false;
        if ($('#directorDialog').length) {
          $('#directorDialog').modal('hide');
        }
  
        if (members.status === 0) {
          this.alert.successWithOk1(members.message, () => {
            $('#directorDialog').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            this.directorForm.reset();
  
            // 🧼 Destroy existing DataTable
            if (this.dtElementMember.dtInstance) {
              this.dtElementMember.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
                // 🆕 Fetch and redraw updated table data
                this.getDirectorDetailsListForTable(this.committeeId); 
              });
            } else {
              this.getDirectorDetailsListForTable(this.committeeId);
            }
  
            // 🔁 Optional re-navigation (depends on your use case)
            this.router.navigate(
              [{ outlets: { 'structure-outlet': ['committee', 'edit', this.committeeId] } }],
              { relativeTo: this.route.parent }
            );
          });
        } else {
          if (members.err_fields) {
            this.alert.error(JSON.stringify(members.err_fields) + ' fields are required or invalid.');
          } else {
            this.alert.error(members.message);
          }
        }
      });
  }
  

  deleteUser(id, type) {
    if (type == 'Director') {
      this.confirmationToDeleteDirector(id);
    } else if (type == 'Member') {
      this.confirmationToDeleteMember(id);
    }
  }

  confirmationToDeleteDirector(director_id) {
    // console.log(director_id);
    $("#deleteModal").modal('toggle')
    this.deletingDirector_id = director_id;
    $("#deleteDirector").show()
    $("#deleteInvitee").hide()
    $("#deleteMember").hide()
    $("#deleteModalMessage").text("Are you sure you want to delete this Director ?");
  }

  confirmationToDeleteInvitee(invitee_id) {
    $("#deleteModal").modal('toggle')
    this.deletingInvitee_id = invitee_id;
    $("#deleteDirector").hide()
    $("#deleteInvitee").show()
    $("#deleteMember").hide()
    $("#deleteModalMessage").text("Are you sure you want to delete this Invitee ?");
  }

  confirmationToDeleteMember(member_id) {
    $("#deleteModal").modal('toggle')
    this.deletingMember_id = member_id;
    $("#deleteDirector").hide()
    $("#deleteInvitee").hide()
    $("#deleteMember").show()
    $("#deleteModalMessage").text("Are you sure you want to delete this Member ?");
  }


  deleteDirector() {
    this.committeeService.deleteCommitteeDir('Director', this.deletingDirector_id, this.committeeId)
      .subscribe((members: any) => {
        $("#deleteModal").modal('toggle');
        if (members.status == 0) {
          this.alert.successWithOk(members.message, 'committee/edit/' + this.committeeId);
          // if (this.dtElementDirector.dtInstance != undefined) {
          //   this.dtElementDirector.dtInstance.then((dtInstance: DataTables.Api) => {
          //     dtInstance.destroy();
          //   });
          // }
          //  this.directorForm.reset();
          // this.getDirectorDetailsListForTable(this.committeeId)
          this.refreshTableOnTabClick('')
        }
        else {
          this.alert.error(members.message);
        }
      });


  }


  deleteInvitee() {
    console.log('this.deletingInvitee_id  this.committeeId', this.deletingInvitee_id, this.committeeId);
    this.committeeService.deleteCommitteeMem('Invitee', this.deletingInvitee_id, this.committeeId)
      .subscribe((members: any) => {
        $("#deleteModal").modal('toggle');
        if (members.status == 0) {
          this.alert.successWithOk(members.message, 'committee/edit/' + this.committeeId);
          this.refreshTableOnTabClick('inviteeTable');
          //   $("#inviteeTable").DataTable().destroy();
          // //  this.directorForm.reset();
          //   this.getDirectorDetailsListForTable(this.committeeId)
        }
        else {
          this.alert.error(members.message);
        }
      });

  }


  deleteMember() {
    this.committeeService.deleteCommitteeMem('Member', this.deletingMember_id, this.committeeId)
      .subscribe((members: any) => {
        $("#deleteModal").modal('toggle');
        if (members.status == 0) {
          $("#memberTablePopup").DataTable().destroy();
          this.alert.successWithOk(members.message, 'committee/edit/' + this.committeeId);
          this.refreshTableOnTabClick('')
          // $("#memberTable").DataTable().destroy();
          //  this.directorForm.reset();
          //this.getDirectorDetailsListForTable(this.committeeId)
          // this.dtTriggerMemberAddingPopup.next();
        }
        else {
          this.alert.error(members.message);
        }
      });

  }

  displayAllActivaedDirectors(data) {
    let activatedDirector = []
    data.forEach(element => {
      console.log('element=============', element);
      activatedDirector.push(element);
      // var appointmentDate = element.OrignalAppointmentDate;
      // var cessationDate = element.OrignalCessationDate;
      // if (appointmentDate == "") {
      //   activatedDirector.push(element);
      //   console.log('Activated Director1',activatedDirector);
      // }
      // else if ((cessationDate == null || moment().diff(moment(cessationDate).format('YYYY-MM-DD'), "days") <= 0)
      //   && moment().diff(moment(appointmentDate).format('YYYY-MM-DD'), "days") >= 0) {
      //   activatedDirector.push(element);
      //   console.log('Activated Director2',activatedDirector);
      // }
      // if (cessationDate != null) {
      //   //Update OrignalCessationDate in the current committee..
      //   console.log('Activated Director3',activatedDirector);
      // }
    });
    this.allDirectorDetailsForCommittee = activatedDirector
  }


  refreshTableOnTabClick(tableID) {
    console.log(this.userSearchDateFrom, this.userSearchDateTo)
    var searchParam = {
      dateFrom: this.userSearchDateFrom ? this.setDate(this.userSearchDateFrom) : null,
      dateTo: this.userSearchDateTo ? this.setDate(this.userSearchDateTo) : null,
    }
    if (tableID == "directorTable") {
      this.allDirectorDetailsForCommittee = [];
      $("#directorTable").DataTable().destroy();
      this.committeeService.getDirectors(this.committeeId, searchParam).subscribe(Data => {
        if (Data.status == 0) {
          // console.log(Data.committeeData.orignalDirectorData);
         this.displayAllActivaedDirectors(Data.committeeData.orignalDirectorData)
         this.allDirectorDetailsForCommittee = Data.committeeData.committeeData[0].Directors;
         this.allDirectorDetailsForCommittee = Data.committeeData.orignalDirectorData;

          this.dtTriggerDirector.next();
        }
        this.availableDirectorsID = [];
        for (var i = 0; i < this.allDirectorDetailsForCommittee.length; i++) {
          this.availableDirectorsID[i] = this.allDirectorDetailsForCommittee[i].DirectorID;
        }
      });
    }
    else if (tableID == "inviteeTable") {
      this.invityMember = [];
      $("#inviteeTable").DataTable().destroy();
      this.committeeService.getDirectors(this.committeeId, searchParam).subscribe(Data => {
        if (Data.status == 0) {
          this.invityMember = Data.committeeData.committeeData[0].Invitees;
          this.dtTriggerInvitee.next();
        }

      });

    }
    else if (tableID == "memberTable") {
      this.committeeMember = [];
      $("#memberTable").DataTable().destroy();
      this.committeeService.getDirectors(this.committeeId, searchParam).subscribe(Data => {
        if (Data.status == 0) {
          this.committeeMember = Data.committeeData.committeeData[0].Members;
          this.dtTriggerMember.next();

        }
      });

    } else {
      // var searchParam = {
      //   dateFrom: this.userSearchDateFrom ? this.setDate(this.userSearchDateFrom) : null,
      //   dateTo: this.userSearchDateTo ? this.setDate(this.userSearchDateTo) : null,
      // }
      $("#directorTable").DataTable().destroy();
      this.committeeService.getDirectors(this.committeeId, searchParam).subscribe(Data => {
        if (Data.status == 0) {
          this.committeeMember = Data.committeeData.committeeData[0].Members;
          // this.dtTriggerMember.next();
          var directorData = Data.committeeData.committeeData[0].Directors;
          if (directorData.length > 0) {
            directorData.forEach(userElement => {
              userElement.name = userElement.DirectorName;
              userElement.userType = 'Director';
            })
          }

          if (this.committeeMember.length > 0) {
            this.committeeMember.forEach(userElement => {
              userElement.name = userElement.MemberName;
              userElement.userType = 'Member';
            })
          }

          console.log(this.committeeMember)
          this.availableDirectorsID = [];
          for (var i = 0; i < directorData.length; i++) {
            this.availableDirectorsID[i] = directorData[i].DirectorID;
          }
          this.allDirectorDetailsForCommittee = directorData.concat(this.committeeMember);
          this.dtTriggerDirector.next();
        }
      });
    }

  }


  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }


  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }



  invitteeListFromGovevea: any[];
  inviteeGovevaMemberSelectBox: any;


  arr_diff(a1, a2) {

    var a = [], diff = [];

    for (var i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
    }

    for (var i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
        delete a[a2[i]];
      } else {
        a[a2[i]] = true;
      }
    }

    for (var k in a) {
      diff.push(k);
    }

    return diff;
  }

  getMembersFromGovevaForInvitee() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#existingInviteeDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#existingInviteeDialog').modal('show');
    }, 100);
    this.inviteeForm.reset();
    this.isExistingInvitteeForInvalid = true;
    this.invitteeListFromGovevea = [];
    this.inviteeGovevaMemberSelectBox = 'null';

    this.inviteeForm.controls.InviteeName.disable();
    this.inviteeForm.controls.Designation.disable();
    this.inviteeForm.controls.MobileNo.disable();
    this.inviteeForm.controls.EmailId.disable();
    this.inviteeForm.controls.InAttendance.setValue('No');
    this.inviteeForm.controls.ThroughVC.setValue('No');

    this.committeeService.getDirectors(this.committeeId, {}).subscribe(Data => {
      if (Data.status == 0) {
        this.committeeMember = Data.committeeData.committeeData[0].Members;
        this.committeeService.getUsersFromGovevaForInvittee().subscribe(test => {


          if (test.status == 0) {

            for (var i = 0; i < this.allDirectorDetailsForCommittee.length; i++) {
              this.allDirectorDetailsForCommittee[i].EmailId = this.allDirectorDetailsForCommittee[i].EmailID;
            }
            this.invitteeListFromGovevea = test.result;
            var other = _.concat(this.committeeMember, this.invityMember, this.allDirectorDetailsForCommittee);


            var ids = new Set(other.map(({ EmailId }) => EmailId));

            this.invitteeListFromGovevea = this.invitteeListFromGovevea.filter(({ EmailId }) => !ids.has(EmailId));


            console.log('this.invitteeListFromGovevea=========', this.invitteeListFromGovevea);



          } else {
            this.invitteeListFromGovevea = []
          }
        })
      }
    })

  }


  selectMemberFromInvittee(event) {
    var id = event.target.value;
    // console.log(event.target.value)
    if (id == null || id == undefined || id == 'null') {
      this.isExistingInvitteeForInvalid = true;
      this.inviteeForm.reset();
      this.inviteeForm.controls.InAttendance.setValue('No');
      this.inviteeForm.controls.ThroughVC.setValue('No');
    } else {
      this.invitteeListFromGovevea.forEach(element => {
        if (element._id == id) {
          this.inviteeForm.controls.InviteeName.setValue(element.Title + '' + element.FirstName + ' ' + element.LastName);
          this.inviteeForm.controls.Designation.setValue(element.Designation);
          this.inviteeForm.controls.MobileNo.setValue(element.MobileNumber);
          this.inviteeForm.controls.EmailId.setValue(element.EmailId);
          this.inviteeForm.controls.GovevaUserId.setValue(element._id);
          this.isExistingInvitteeForInvalid = false;
        }
      })
    }

  }
  showinviteeDialog() {

    $('#msgDialog').off('hidden.bs.modal');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#msgDialog').modal('hide');

    // Clean any leftover state just to be safe
    $('#inviteeDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#inviteeDialog').modal('show');
    }, 100);
  }

  saveInviteeForGoveva() {
    this.disabledOnclick = true;
    if (this.inviteeForm.valid) {
      var invityMember = {
        InviteeName: this.inviteeForm.controls.InviteeName.value,
        Designation: this.inviteeForm.controls.Designation.value,
        Address: this.inviteeForm.controls.Address.value,
        City: this.inviteeForm.controls.City.value,
        State: this.inviteeForm.controls.State.value,
        TelO: this.inviteeForm.controls.TelO.value,
        TelR: this.inviteeForm.controls.TelR.value,
        FaxNo: this.inviteeForm.controls.FaxNo.value,
        MobileNo: this.inviteeForm.controls.MobileNo.value,
        EmailId: this.inviteeForm.controls.EmailId.value,
        InAttendance: this.inviteeForm.controls.InAttendance.value,
        ThroughVC: this.inviteeForm.controls.ThroughVC.value,
        GovevaUserId: this.inviteeForm.controls.GovevaUserId.value,
      }
      // console.log(invityMember);
      this.committeeService.addCommitteeInvitee(invityMember, this.committeeId)
        .subscribe(members => {
          this.disabledOnclick = false;
          $("#existingInviteeDialog").modal('hide');
          $('#inviteeDialog').modal('hide')
          if (members.status == 0) {
            this.alert.successWithOk1(members.message, () => {
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['committee', 'edit', this.committeeId] } }],
                { relativeTo: this.route.parent });
              $('#existingInviteeDialog').off('hidden.bs.modal');
              $('#inviteeDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
            });
            // $("#inviteeTable").DataTable().destroy();
            this.refreshTableOnTabClick("inviteeTable")
            // if (this.dtElementInvitee.dtInstance != undefined) {
            //   this.dtElementInvitee.dtInstance.then((dtInstance: DataTables.Api) => {
            //     dtInstance.destroy();
            //   });
            // }

            this.inviteeForm.reset();
            //this.getDirectorDetailsListForTable(this.committeeId)
          }
          else {

            // this.alert.error(members.message);
            this.alert.error(JSON.stringify(members.message) + ' fields are required or invalid.');
          }
        });

    } else {
      this.disabledOnclick = false;
      return false
    }

  }

  /* (17-04-2019) */

  getUserByType(type) {
    // this.directorData = [];

    // console.log(this.directorData)
    this.directorForm.controls.DirectorDIN.setValue(null);
    this.directorForm.controls.Designation.setValue('');
    this.directorForm.controls.Category.setValue('');
    this.directorForm.controls.DirectorID.setValue('');
    this.directorForm.controls.MemberName.setValue('');
    this.directorForm.controls.EmailID.setValue('');
    this.directorForm.controls.IsExecutive.setValue('');
    if (type == 'Director') {
      this.getDirectorsDIN();
    } else if (type == 'Member') {
      // this.addMember();
      this.getMembersFromGoveva()
    }
    this.directorForm.controls.MemberType.setValue(type);
  }

  reInitializeMembers(type) {
    if (type == 'Director') {
      this.directorData = this.directorData;
    } else if (type == 'Member') {
      this.directorData = this.membersListFromGovEva;
    }
  }

  /* (18-04-2019) */

  getUserByTypeOnEdit(type) {
    var filteredData
    if (type == 'Director') {
      var dir = this.directorData.findIndex(x => x.DirectorID == this.directorForm.controls.DirectorID.value);
      filteredData = this.directorData[dir];
    } else if (type == 'Member') {
      var mem = this.committeeMember.findIndex(x => x.EmailId == this.directorForm.controls.EmailID.value);
      filteredData = this.committeeMember[mem];
    }
    console.log(this.directorData);
    this.getDirectorsDINOnEdit(filteredData, type);

  }

  filterUserByDate() {
    var dateObj = new Date();
    this.todayDateforSearchUser = { year: dateObj.getUTCFullYear(), month: dateObj.getUTCMonth() + 1, day: dateObj.getUTCDate() };
    this.minDateForSearchTo = this.userSearchDateFrom;
    //console.log(this.MinDocumentDateDate);
  }

  clear() {
    this.userSearchDateFrom = null;
    this.userSearchDateTo = null;
    this.refreshTableOnTabClick('');
  }

  maskEmail(email: string): string {
  if (email) {
    const [username, domain] = email.split('@');
    return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
  }
  return '';
}
}
